export class AdminData {
  id: string='';
  name: string='';
  hospitalName: string='';
  emailId: string='';
  mobileNo: string = '';
  licenseType: number;
  licenseNo: string = '';
  validDays: number = 0;
  validDevices: number = 0;
  isUsed: boolean = false;
  createdAt: string;
  expireOn: Date;
  isLock: boolean = false;
  backgroundColor: string = "white";
  CreatedAt: Date;
  expired: boolean;
  photoUrl: string;
  totalMemory: string;
  amount :number=0;
  deviceAmount :number=0;
  productId :string='';
  productType :number;
  isPaymentPending :boolean=false;
  amountRecieved:number=0;
  paymentType:number;
  productName:string="";
  tooltipFirstTime:boolean=false;
  haLoginUsername:string;
  productAccessType:boolean;

}
